// extracted by mini-css-extract-plugin
export default {"infoCards_Container":"InfoCards_infoCards_Container__GkTGY","infoCardContainer":"InfoCards_infoCardContainer__NQzUu"};